import { MeFragment } from "lib/graphql"

export function hasCompletedProfile(me?: MeFragment | null) {
  return me && me.lastName && me.address && me.postcode && me.residence && me.pronounsMulti?.length > 0
}
